/**
 * Generated file
 * Do not edit directly
 */
import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const CloseSolidCircleIcon = ({ css, ...props }: IconProps) => {
  return (
    <Icon
      height="16px"
      width="16px"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6667 7.99998C14.6667 11.6819 11.6819 14.6666 8 14.6666C4.3181 14.6666 1.33333 11.6819 1.33333 7.99998C1.33333 4.31808 4.3181 1.33331 8 1.33331C11.6819 1.33331 14.6667 4.31808 14.6667 7.99998ZM7.29255 7.99998L4.97913 5.68656L5.68623 4.97946L7.99964 7.29287L10.313 4.9795L11.0201 5.6866L8.70674 7.99997L11.0201 10.3133L10.313 11.0204L7.99965 8.70708L5.68623 11.0205L4.97913 10.3134L7.29255 7.99998Z"
        fill="currentColor"
      ></path>
    </Icon>
  );
};
